"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MediaRenderer = void 0;
const MediaRenderer = (props) => {
    const { component, media } = props;
    return component({
        ...media,
        src: media.file,
    });
};
exports.MediaRenderer = MediaRenderer;
